module.exports = {
	"config": {
		"ru": "Промхим-Сфера",
		"en": "PromHim-Sfera"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js"
			},
			"requirePath": "404.js",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "clients",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "clients",
				"stem": "index",
				"path": "clients/index.js"
			},
			"requirePath": "clients/index.js",
			"path": "/clients/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "contacts",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "contacts",
				"stem": "index",
				"path": "contacts/index.js"
			},
			"requirePath": "contacts/index.js",
			"path": "/contacts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "equipment",
				"stem": "_template",
				"path": "equipment/_template.jsx"
			},
			"requirePath": "equipment/_template.jsx",
			"templatePath": "/equipment/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/blower",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/blower",
				"stem": "en",
				"path": "equipment/blower/en.js"
			},
			"requirePath": "equipment/blower/en.js",
			"path": "/equipment/blower/",
			"data": {
				"title": "Gas blowers",
				"path": "/equipment/blower/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/blower",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/blower",
				"stem": "ru",
				"path": "equipment/blower/ru.js"
			},
			"requirePath": "equipment/blower/ru.js",
			"path": "/equipment/blower/",
			"data": {
				"title": "Газодувки",
				"path": "/equipment/blower/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/corrosion-monitoring",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/corrosion-monitoring",
				"stem": "en",
				"path": "equipment/corrosion-monitoring/en.js"
			},
			"requirePath": "equipment/corrosion-monitoring/en.js",
			"path": "/equipment/corrosion-monitoring/",
			"data": {
				"title": "Corrosion monitoring",
				"path": "/equipment/corrosion-monitoring/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/corrosion-monitoring",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/corrosion-monitoring",
				"stem": "ru",
				"path": "equipment/corrosion-monitoring/ru.js"
			},
			"requirePath": "equipment/corrosion-monitoring/ru.js",
			"path": "/equipment/corrosion-monitoring/",
			"data": {
				"title": "Мониторинг коррозии",
				"path": "/equipment/corrosion-monitoring/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/fire-protection",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/fire-protection",
				"stem": "en",
				"path": "equipment/fire-protection/en.js"
			},
			"requirePath": "equipment/fire-protection/en.js",
			"path": "/equipment/fire-protection/",
			"data": {
				"title": "Fire protection",
				"path": "/equipment/fire-protection/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/fire-protection",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/fire-protection",
				"stem": "ru",
				"path": "equipment/fire-protection/ru.js"
			},
			"requirePath": "equipment/fire-protection/ru.js",
			"path": "/equipment/fire-protection/",
			"data": {
				"title": "Огнезащита",
				"path": "/equipment/fire-protection/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/fitting",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/fitting",
				"stem": "en",
				"path": "equipment/fitting/en.js"
			},
			"requirePath": "equipment/fitting/en.js",
			"path": "/equipment/fitting/",
			"data": {
				"title": "Pipeline equipment",
				"path": "/equipment/fitting/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/fitting",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/fitting",
				"stem": "ru",
				"path": "equipment/fitting/ru.js"
			},
			"requirePath": "equipment/fitting/ru.js",
			"path": "/equipment/fitting/",
			"data": {
				"title": "Арматура",
				"path": "/equipment/fitting/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-compressor",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/nko-compressor",
				"stem": "en",
				"path": "equipment/nko-compressor/en.js"
			},
			"requirePath": "equipment/nko-compressor/en.js",
			"path": "/equipment/nko/compressor/",
			"data": {
				"title": "Compressors",
				"path": "/equipment/nko/compressor/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-compressor",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/nko-compressor",
				"stem": "ru",
				"path": "equipment/nko-compressor/ru.js"
			},
			"requirePath": "equipment/nko-compressor/ru.js",
			"path": "/equipment/nko/compressor/",
			"data": {
				"title": "Компрессоры",
				"path": "/equipment/nko/compressor/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-mps",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/nko-mps",
				"stem": "en",
				"path": "equipment/nko-mps/en.js"
			},
			"requirePath": "equipment/nko-mps/en.js",
			"path": "/equipment/nko/mps/",
			"data": {
				"title": "Multiphase pumping station",
				"path": "/equipment/nko/mps/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-mps",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/nko-mps",
				"stem": "ru",
				"path": "equipment/nko-mps/ru.js"
			},
			"requirePath": "equipment/nko-mps/ru.js",
			"path": "/equipment/nko/mps/",
			"data": {
				"title": "Мультифазные насосные станции",
				"path": "/equipment/nko/mps/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-pump",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/nko-pump",
				"stem": "en",
				"path": "equipment/nko-pump/en.js"
			},
			"requirePath": "equipment/nko-pump/en.js",
			"path": "/equipment/nko/pump/",
			"data": {
				"title": "Pumps",
				"path": "/equipment/nko/pump/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/nko-pump",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/nko-pump",
				"stem": "ru",
				"path": "equipment/nko-pump/ru.js"
			},
			"requirePath": "equipment/nko-pump/ru.js",
			"path": "/equipment/nko/pump/",
			"data": {
				"title": "Насосы",
				"path": "/equipment/nko/pump/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/test-stand",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/test-stand",
				"stem": "en",
				"path": "equipment/test-stand/en.js"
			},
			"requirePath": "equipment/test-stand/en.js",
			"path": "/equipment/test-stand/",
			"data": {
				"title": "Test facility",
				"path": "/equipment/test-stand/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/test-stand",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/test-stand",
				"stem": "ru",
				"path": "equipment/test-stand/ru.js"
			},
			"requirePath": "equipment/test-stand/ru.js",
			"path": "/equipment/test-stand/",
			"data": {
				"title": "Испытательные стенды",
				"path": "/equipment/test-stand/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/tube-cleaning",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/tube-cleaning",
				"stem": "en",
				"path": "equipment/tube-cleaning/en.js"
			},
			"requirePath": "equipment/tube-cleaning/en.js",
			"path": "/equipment/tube-cleaning/",
			"data": {
				"title": "Pipelines treating facility",
				"path": "/equipment/tube-cleaning/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/tube-cleaning",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/tube-cleaning",
				"stem": "ru",
				"path": "equipment/tube-cleaning/ru.js"
			},
			"requirePath": "equipment/tube-cleaning/ru.js",
			"path": "/equipment/tube-cleaning/",
			"data": {
				"title": "Очистные устройства для трубопроводов",
				"path": "/equipment/tube-cleaning/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/valve",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/valve",
				"stem": "en",
				"path": "equipment/valve/en.js"
			},
			"requirePath": "equipment/valve/en.js",
			"path": "/equipment/valve/",
			"data": {
				"title": "Valves",
				"path": "/equipment/valve/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/valve",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/valve",
				"stem": "ru",
				"path": "equipment/valve/ru.js"
			},
			"requirePath": "equipment/valve/ru.js",
			"path": "/equipment/valve/",
			"data": {
				"title": "Клапаны",
				"path": "/equipment/valve/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/ventilation",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/ventilation",
				"stem": "en",
				"path": "equipment/ventilation/en.js"
			},
			"requirePath": "equipment/ventilation/en.js",
			"path": "/equipment/ventilation/",
			"data": {
				"title": "Ventilation",
				"path": "/equipment/ventilation/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/ventilation",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/ventilation",
				"stem": "ru",
				"path": "equipment/ventilation/ru.js"
			},
			"requirePath": "equipment/ventilation/ru.js",
			"path": "/equipment/ventilation/",
			"data": {
				"title": "Вентиляция",
				"path": "/equipment/ventilation/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/zip",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/zip",
				"stem": "en",
				"path": "equipment/zip/en.js"
			},
			"requirePath": "equipment/zip/en.js",
			"path": "/equipment/zip/",
			"data": {
				"title": "Spare parts",
				"path": "/equipment/zip/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/zip",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/zip",
				"stem": "ru",
				"path": "equipment/zip/ru.js"
			},
			"requirePath": "equipment/zip/ru.js",
			"path": "/equipment/zip/",
			"data": {
				"title": "Зип",
				"path": "/equipment/zip/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/reagents",
				"base": "en.js",
				"ext": "js",
				"name": "en",
				"extname": ".js",
				"basename": "en.js",
				"dirname": "equipment/reagents",
				"stem": "en",
				"path": "equipment/reagents/en.js"
			},
			"requirePath": "equipment/reagents/en.js",
			"path": "/equipment/reagents/",
			"data": {
				"title": "Water treatment reagents",
				"path": "/equipment/reagents/",
				"description": null,
				"keywords": [],
				"lang": "en"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "equipment/reagents",
				"base": "ru.js",
				"ext": "js",
				"name": "ru",
				"extname": ".js",
				"basename": "ru.js",
				"dirname": "equipment/reagents",
				"stem": "ru",
				"path": "equipment/reagents/ru.js"
			},
			"requirePath": "equipment/reagents/ru.js",
			"path": "/equipment/reagents/",
			"data": {
				"title": "Реагенты для водоподготовки",
				"path": "/equipment/reagents/",
				"description": null,
				"keywords": [],
				"lang": "ru"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "press",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "press",
				"stem": "index",
				"path": "press/index.js"
			},
			"requirePath": "press/index.js",
			"path": "/press/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0
